const isOffWhiteSmooth = attribute => {
    return 'Off White - Smooth' === attribute.value
}

export const shouldUseMattingTypePricing = attribute => {
    return isOffWhiteSmooth(attribute)
}

export const withMattingTypePricing = (price, mattingPrice, selectedMattingType = null) => {
    if(selectedMattingType) {
        return (parseFloat(price) + mattingPrice * 0.2).toFixed(2)
    }

    return (parseFloat(price) + mattingPrice * 0.15).toFixed(2)
}

export const getMattingPrice = (mattingTypeAttribute, paperTypeAttribute = null) => {
    const attribute = mattingTypeAttribute ?? paperTypeAttribute

    if (attribute) {
        const selectedOption = attribute.options.filter(option => {
            return option.value === attribute.value
        })

        return 1 === selectedOption.length ? parseFloat(selectedOption[0].price) : 0
    }

    return 0
}